import axios from 'axios'
import store from '../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function voucherSearch (pFormdata) {
    const URI = `${BASE_URL}/api/voucher-search`
    return axios.post(URI, pFormdata, { headers })
}

export { voucherSearch }